import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { nextActions } from '../actions/next.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class NextEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getNext$ = createEffect(() => {
        return this.actions.pipe(
            ofType(nextActions.getNextContent),
            mergeMap(() => {
                return this.httpService.getNext().pipe(
                    map((payload) => nextActions.getNextContentSuccess({ payload })),
                    catchError(() => of(nextActions.getNextContentError())),
                );
            }),
        );
    });
}
